import React, { useState } from "react";
import { RiArrowDownSLine } from "react-icons/ri";

const Accordion = ({ description, name, Icon }) => {
  const [accordionOpen, setAccordionOpen] = useState(false);
  return (
    <div className="">
      <button
        onClick={() => setAccordionOpen(!accordionOpen)}
        className={`flex justify-between w-full py-2 px-2 rounded-lg text-sm text-black border border-Main transition-all ${
          accordionOpen ? "bg-gradient-to-t from-Main to-[#2F7EAB] mb-2" : ""
        }`}
      >
        <div className="flex items-center gap-2">
          <div>
            <Icon
              size={25}
              className={`${
                accordionOpen ? "text-white" : "text-Main"
              } mx-auto my-2 `}
            />
          </div>
          <span
            className={`${accordionOpen ? "text-white" : "text-[#D5EAF5]"}`}
          >
            {name}
          </span>
        </div>
        {
          <RiArrowDownSLine
            size={20}
            className={`${
              accordionOpen
                ? "rotate-180 transition-all text-white"
                : "rotate-0 transition-all text-Main"
            }`}
          />
        }
      </button>
      <div
        className={`grid overflow-hidden transition-all duration-300 ease-in-out text-gray-600 text-sm ${
          accordionOpen
            ? "grid-rows-[1fr] opacity-100"
            : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden px-1 space-y-1">
          <div className="flex items-center gap-2 py-2 px-2 block hover:rounded-lg text-sm text-gray-700 bg-gradient-to-t from-gray-400 to-[#F7FAFC] rounded-lg transition-all">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
